module.exports = __webpack_public_path__ + "static/media/44.e6df189.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/44.wav
// module id = j6PJ
// module chunks = 0